import React, { useState, useMemo, useCallback, memo } from "react"
import Role from "@/components/invitation/Role"
import OutputActive from "@/components/invitation/OutputActive"
import Designation from "@/components/invitation/Designation"
import Department from "@/components/invitation/Department"
import Typography from "@material-ui/core/Typography"
import Box from "@material-ui/core/Box"
import Button from "@material-ui/core/Button"
import { Alert } from "@material-ui/lab"
import { updateParticipantByUUID } from "@/apisParticipantPublic"
import { useNavigate, useSearchParams } from "react-router-dom"
import { urlPath } from "@/utils"

const InvitationMain = memo((props) => {
    const { participant, participantUUID, handleUpdateParticipant, setParticipantDetailError } = props
    const [participantRoleSettingError, setParticipantRoleSettingError] = useState({
        show: false,
        message: "",
    })

    const [searchParams] = useSearchParams()
    const participantPublicAccessToken = searchParams.get("token")

    const navigate = useNavigate()

    const updateRoleSetting = useCallback(async () => {
        setParticipantRoleSettingError({
            show: false,
            message: "",
        })
        try {
            const participantToUpdate = { ...participant }
            participantToUpdate.active = true
            await updateParticipantByUUID(participantUUID, participantToUpdate)
            participant.active = true
            // jump to assessment
            navigate(urlPath("assessment", undefined, { participantUUID, token: participantPublicAccessToken }))
        } catch (error) {
            setParticipantDetailError({
                status: true,
                message: "update failed",
                update: true,
            })
        }
    }, [participantUUID, participant])

    const saveParticipantRoleSettings = useCallback(async () => {
        if (participant.roleId === null) {
            setParticipantRoleSettingError({
                show: true,
                message: "Please set your role",
            })
        } else if (participant.roleId !== 0) {
            if (!participant.designationId) {
                setParticipantRoleSettingError({
                    show: true,
                    message: "Please select your designation",
                })
            } else if (!participant.departmentId) {
                setParticipantRoleSettingError({
                    show: true,
                    message: "Please select your department",
                })
            } else {
                await updateRoleSetting()
            }
        } else {
            // participant role is 0
            await updateRoleSetting()
        }
    }, [participant])

    const buttonDisplay = useMemo(() => {
        if (participant.roleId === null) {
            return null
        }
        if (participant.roleId === 0) {
            return (
                <Box style={{ textAlign: "center" }}>
                    <Button variant="contained" color="primary" onClick={saveParticipantRoleSettings}>
                        Save Changes
                    </Button>
                </Box>
            )
        }
        return (
            <Box style={{ textAlign: "center" }}>
                <Button variant="contained" color="primary" onClick={saveParticipantRoleSettings}>
                    Save changes
                </Button>
            </Box>
        )
    }, [participant])
    if (participant.active === true) {
        return <OutputActive participantRole={participant.roleId} participantUUID={participantUUID} />
    }
    return (
        <Box my={10} mx={4}>
            <Box display="flex" justifyContent="center">
                <Typography variant="h5" component="h1" style={{ color: "black" }}>
                    Role Selection
                </Typography>
            </Box>
            <Role
                participantUUID={participantUUID}
                participant={participant}
                handleUpdateParticipant={handleUpdateParticipant}
                setParticipantDetailError={setParticipantDetailError}
                setParticipantRoleSettingError={setParticipantRoleSettingError}
            />
            <Designation
                participantUUID={participantUUID}
                participant={participant}
                handleUpdateParticipant={handleUpdateParticipant}
                setParticipantDetailError={setParticipantDetailError}
                setParticipantRoleSettingError={setParticipantRoleSettingError}
            />
            <Department
                participantUUID={participantUUID}
                participant={participant}
                handleUpdateParticipant={handleUpdateParticipant}
                setParticipantDetailError={setParticipantDetailError}
                setParticipantRoleSettingError={setParticipantRoleSettingError}
            />
            <Box display="flex" justifyContent="center" mt={6} flexDirection="column">
                {buttonDisplay}
                <Box mt={3}>
                    {participantRoleSettingError.show && <Alert severity="error">{participantRoleSettingError.message}</Alert>}
                </Box>
            </Box>
        </Box>
    )
})

export default InvitationMain
